import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import Image from 'src/components/images/Image';
import { convert } from "src/components/streaming/streamingtitlewithproviders/CommonDataStructure";
import ProviderScroller from 'src/components/streaming/streamingtitlewithproviders/ProviderScroller';
import { StreamingContent, WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import classNames from 'classnames';
import styles from './StreamingTitleWithProviders.module.css';

//#region [Props]
type StreamingTitleWithProvidersProps = {
	data: StreamingContent | WatchableContent;
	isCinemaRelevant?: boolean;
	useOverrideCinemaRelevant?: boolean;
};
//#endregion

// MAYBE: shopPop? Tror dette kun var for debugging


//#region [Component]
export default function StreamingTitleWithProviders({ data, isCinemaRelevant = false, useOverrideCinemaRelevant = false }: StreamingTitleWithProvidersProps) {
	const _data = convert(data);
	const _isCinRel = (useOverrideCinemaRelevant && isCinemaRelevant) || _data.isCinemaRelevant;
	const url = _isCinRel ?
		`/film/${_data.filmwebMovieId}`
		: `/streamingguide/${_data.isSeries ? "serie" : "film"}/${_data.streamingId}`;

	// Always use sanity poster if present with fallback to streaming poster (which field is present is controlled by movieinfo)
	// isCinemaRelevant does not affect the use of images.
	const useSanityImage = !!_data.sanityImagePosterUrl;
	const useStreamingImage = !useSanityImage && (_data.imagesPoster?.length ?? 0) > 0;

	return <article className={styles.SStreamingTitle}>
		{/*<div className={styles.SPopDEBUG}>{data.popularity}</div>*/}
		<div className={styles.SPosterContainer}>
			<FilmwebLink className={classNames(styles.SPosterLink, {
				[styles.cinemaRelevant]: _isCinRel
			})} to={url} data-missingtext="Plakat mangler">
				{useSanityImage && <CmsImageForUrl imageUrl={_data.sanityImagePosterUrl!} alt={_data.title} sizes={SIZES} />}
				{useStreamingImage && <Image image={_data.imagesPoster!} alt={_data.title} sizes={SIZES} />}
			</FilmwebLink>
		</div>
		<div className={styles.SHeaderContainer}>
			<header className={styles.SHeader}>
				<FilmwebLink className={styles.SHeaderLink} to={url}>
					<h1 className={styles.STitle}>{_data.title}</h1>
					{_data.year && _data.year.length > 3 && <span className={styles.SYear}>{_data.year}</span>}
				</FilmwebLink>
			</header>
			<ProviderScroller className={styles.SProviderScroller} data={_data} isCinemaRelevant={isCinemaRelevant} useCinemaRelevantProp={useOverrideCinemaRelevant} />
		</div>

	</article>;
}
//#endregion

const SIZES = `(min-width: 550px) 365px, 100vw`;

